const state = {
  errors: [],
}

const mutations = {
  set_error (state, error) {
    state.errors.push(error)
  },
  remove_error (state, errorId) {
    state.errors.splice(errorId, 1)
  },
}

const actions = {}

export default {
  state,
  mutations,
  actions,
}
